import React from 'react';

export const SvgNavMapPins = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_448_312)">
        <path
          d="M9.90736 11.5246L11.5926 13.8803L13.2778 11.5246C15.7059 10.7998 17.4817 8.55288 17.4817 5.88917C17.4817 2.63654 14.8452 0.00906372 11.6016 0.00906372C8.35806 0.00906372 5.72153 2.6456 5.72153 5.88917C5.72153 8.55288 7.49734 10.7998 9.92548 11.5246H9.90736ZM11.5835 1.35904C14.0751 1.35904 16.1046 3.38854 16.1046 5.88011C16.1046 8.37167 14.0751 10.4012 11.5835 10.4012C9.09194 10.4012 7.06244 8.37167 7.06244 5.88011C7.06244 3.38854 9.09194 1.35904 11.5835 1.35904Z"
          fill="currentColor"
        />
        <path
          d="M6.71816 15.7377C6.34669 15.7377 6.03864 16.0457 6.03864 16.4172C6.03864 16.7886 6.34669 17.0967 6.71816 17.0967H9.87112C10.2426 17.0967 10.5506 16.7886 10.5506 16.4172C10.5506 16.0457 10.2426 15.7377 9.87112 15.7377H6.71816Z"
          fill="currentColor"
        />
        <path
          d="M11.5835 18.1749C11.212 18.1749 10.904 18.4829 10.904 18.8544C10.904 19.2259 11.212 19.5339 11.5835 19.5339H14.2291C14.6006 19.5339 14.9086 19.2259 14.9086 18.8544C14.9086 18.4829 14.6006 18.1749 14.2291 18.1749H11.5835Z"
          fill="currentColor"
        />
        <path
          d="M16.7207 14.6957C16.7207 14.3243 16.4126 14.0162 16.0412 14.0162H13.305C12.9335 14.0162 12.6254 14.3243 12.6254 14.6957C12.6254 15.0672 12.9335 15.3752 13.305 15.3752H16.0412C16.4126 15.3752 16.7207 15.0672 16.7207 14.6957Z"
          fill="currentColor"
        />
        <path
          d="M21.5498 14.0343L16.9472 10.6548C16.6482 10.4283 16.2224 10.5008 15.9959 10.7998C15.7693 11.0988 15.8418 11.5246 16.1408 11.7511L20.7434 15.1306C20.8703 15.2303 20.9518 15.3752 20.9518 15.5383C20.9518 15.7014 20.8793 15.8464 20.7434 15.946L11.8825 22.4604C11.7013 22.5872 11.4657 22.5872 11.2936 22.4604L2.43266 15.937C2.30581 15.8373 2.22427 15.6923 2.22427 15.5293C2.22427 15.3662 2.29675 15.2212 2.43266 15.1216L7.03526 11.7421C7.33425 11.5156 7.40673 11.0988 7.18023 10.7908C6.95372 10.4827 6.53695 10.4193 6.2289 10.6458L1.6263 14.0343C1.1461 14.3877 0.865234 14.9313 0.865234 15.5293C0.865234 16.1272 1.13704 16.6709 1.6263 17.0242L10.4872 23.5385C10.8134 23.7832 11.203 23.9009 11.5926 23.9009C11.9822 23.9009 12.3627 23.7832 12.6979 23.5385L21.5588 17.0242C22.039 16.6709 22.3199 16.1272 22.3199 15.5293C22.3199 14.9313 22.0481 14.3877 21.5588 14.0343H21.5498Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_448_312">
          <rect
            width="21.4456"
            height="23.91"
            fill="currentColor"
            transform="translate(0.865234)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
